import "./Footer.css";
import axios from "axios";
import { useContext, useEffect, useState } from "react";
import { format, addMilliseconds } from "date-fns";
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';

import CookieContext from "../contexts/CookieContext";
import ExpTimeContext from "../contexts/ExpTimeContext";

import AppContext from "../contexts/AppContext";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: '#e9dfdf',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
  ...theme.applyStyles('dark', {
    backgroundColor: '#1A2027',
  }),
}));

const Footer = () => {
  const { apiHost, AppButton } = useContext(AppContext);
  const basePath = 'httprequest/';
  const { cookies, refreshJwtCookies } = useContext(CookieContext);
  const interval = 5000;
  const [id, setId] = useState("");
  const [ip, setIp] = useState("");
  const [clock, setClock] = useState("00:00:00");

  const { leftTime, leftTimeMs, leftTimeDhms } = useContext(ExpTimeContext);

  const [elevation, setElevation] = useState('6');

  // const [authorization, setAuthorization] = useState();

  // 0.2秒毎に更新
  const [intervalTime, setIntervalTime] = useState(200);
  // intervalAccessTime = interval + responseTimeで接続の度に更新
  const [intervalAccessTime, setIntervalAccessTime] = useState(interval);
  // nextAccessTimeは次回アクセスの参考表示用
  const [nextAccessTime, setNextAccessTime] = useState(
    format(addMilliseconds(Date.now(), interval), "HH:mm:ss")
  );

  const [responseTime, setResponseTime] = useState(0);

  // 前回記録保持用
  const [lastRequestDate, setLastRequestDate] = useState("1999-12-31 23:59:59");
  const [lastResponseDate, setLastResponseDate] = useState("1999-12-31 23:59:59");

  const updateClock = async () => {
    // 出力フォーマット
    // const curTime = format(Date.now(), "HH:mm:ss.S");
    const curTime = format(Date.now(), "HH:mm:ss");
    setClock(curTime);
  };

  const axios_fetch = async () => {
    const start = Date.now();
    try {
      if (cookies.jwtAccess) {
        // jwtがある場合、headers（認証情報）有り
        await axios({
          method: "get",
          url: apiHost + basePath,
          headers: {
            "Content-Type": "application/json",
            Authorization: `JWT ${cookies.jwtAccess}`,
          },
          params: {
            // last_request_time: "1999-01-01 01:01:01",
            // last_response_time: "2000-01-01 01:01:01",
            last_request_date: lastRequestDate,
            last_response_date: lastResponseDate,
            response_time: responseTime,
          },
        }).then(async (response) => {
          await console.log(response);
          await setId(response.data[0].id);
          await setIp(response.data[0].ip_addr);
        });
      } else {
        // jwtがない場合、headers（認証情報）無し
        await axios({
          method: "get",
          url: apiHost + basePath,
          params: {
            // last_request_time: "2009-12-31 23:59:59",
            // last_response_time: "2010-12-31 23:59:59",
            last_request_date: lastRequestDate,
            last_response_date: lastResponseDate,
            response_time: responseTime,
          },
        }).then(async (response) => {
          await console.log(response);
          await setId(response.data[0].id);
          await setIp(response.data[0].ip_addr);
        });
      }
    } catch (error) {
      return;
    }
    const finish = Date.now();

    // 次回リクエスト時に送信するために値を格納
    await setLastRequestDate(format(start, "yyyy-MM-dd HH:mm:ss.SSS"));
    await setLastResponseDate(format(finish, "yyyy-MM-dd HH:mm:ss.SSS"));

    // await setLastRequestDate();
    // formatInTimeZone(start, "Asia/Tokyo", "yyyy-MM-dd HH:mm:ss.SSS xxx")
    // TZDate(start, "Asia/Tokyo", "yyyy-MM-dd HH:mm:ss.SSS xxx")
    // await setLastResponseDate();
    // formatInTimeZone(finish, "Asia/Tokyo", "yyyy-MM-dd HH:mm:ss.SSS xxx")
    // TZDate(finish, "Asia/Tokyo", "yyyy-MM-dd HH:mm:ss.SSS xxx")
    await setResponseTime(finish - start);
    await setIntervalAccessTime(interval + responseTime);

    await setNextAccessTime(format(addMilliseconds(Date.now(), interval + responseTime), "HH:mm:ss"));
    // TZDate(addMilliseconds(Date.now(), interval + responseTime), "HH:mm:ss")
  };

  // 時刻表示用（レスポンスタイム考慮無し）
  useEffect(() => {
    const timer = setInterval(
      () => {
        updateClock();
      },
      intervalTime,
      [ip]
    );
    return () => {
      clearInterval(timer);
    };
  }, [clock]);

  // 更新時間表示用（レスポンスタイム考慮有り）
  useEffect(() => {
    const timer = setInterval(
      () => {
        axios_fetch();
      },
      intervalAccessTime,
      []
    );
    return () => {
      clearInterval(timer);
    };
  }, [nextAccessTime]);

  // 初回アクセス時に一度だけ実行（2回目以降は「nextAccessTime」更新時に実行）
  useEffect(() => {
    axios_fetch();
  }, []);

  return (
    <>
      <div className="bd-callout bd-callout-warning" style={{ margin: "5px" }}>
        【NW/自動更新情報】
        <Box>
          <Grid container spacing={2}>
            <Grid size={6}>
              <Item elevation={elevation}>ip:{ip ? ip : "xxx.xxx.xxx.xxx"}</Item>
            </Grid>
            <Grid size={6}>
              <Item elevation={elevation}>次回更新:{nextAccessTime}</Item>
            </Grid>
            <Grid size={6}>
              {/* <Item elevation={elevation}>応答時間:{responseTime}ms&nbsp;(serial {id ? id : "X"})</Item> */}
              <Item elevation={elevation}>応答時間:{responseTime}ms</Item>
            </Grid>
            <Grid size={6}>
              {/* <Item elevation={elevation}>nextAccessIntervalTime:{Math.round(intervalAccessTime / 100) / 10}s（{intervalAccessTime}ms）</Item> */}
              <Item elevation={elevation}>インターバル:{Math.round(intervalAccessTime / 100) / 10}秒</Item>
            </Grid>
          </Grid>
        </Box>
      </div>
      <div className="bd-callout bd-callout-warning" style={{ margin: "5px" }}>
          【認証情報】
          {/* ログインしていたらユーザ情報表示 */}
          <Box>
          <Grid container spacing={2}>
            <Grid size={6}>
              {/* <Item elevation={elevation}>accessTokenUserId:{cookies.accessTokenUserId ? cookies.accessTokenUserId : "-"}</Item> */}
              <Item elevation={elevation}>ユーザID:{cookies.accessTokenUserId ? cookies.accessTokenUserId : "-"}</Item>
            </Grid>
            <Grid size={6}>
              {/* <Item elevation={elevation}>accessTokenUsername:{cookies.accessTokenUsername ? cookies.accessTokenUsername : "guest"}</Item> */}
              <Item elevation={elevation}>ユーザ名:{cookies.accessTokenUsername ? cookies.accessTokenUsername : "guest"}</Item>
            </Grid>
            <Grid size={6}>
              {/* <Item elevation={elevation}>accessTokenUuid:{cookies.accessTokenUuid ? cookies.accessTokenUuid : "XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX"}</Item> */}
              <Item elevation={elevation}>Uuid:{cookies.accessTokenUuid ? cookies.accessTokenUuid.slice(0, 8) : "XXXXXXXX"}</Item>
            </Grid>
            <Grid size={6}>
              <Item elevation={elevation}>期限:{cookies.accessTokenExpTime ? cookies.accessTokenExpTime : "XXXX/XX/XX XX:XX:XX"}</Item>
            </Grid>

            <Grid size={12}>

            <AppButton
              // className="refreshTokenExp"
              // variant="contained"
              onClick={refreshJwtCookies}
            >
              <span className="material-symbols-outlined">
                認証期限延長（{leftTimeDhms(cookies.refreshTokenExp)}）
              </span>
            </AppButton>
            </Grid>


          </Grid>
        </Box>
      </div>
      <div className="bd-callout bd-callout-warning" style={{ margin: "5px" }}>
        【時計】
        <Box>
          <Grid container spacing={2}>
            <Grid size={6}>
              {/* <Item elevation={elevation}>clock:{clock}({intervalTime}ms)</Item> */}
              <Item elevation={elevation}>{clock}</Item>
            </Grid>
            <Grid size={6}>
            </Grid>
          </Grid>
        </Box>
      </div>
    </>
  );
};
export default Footer
